import { 
  Edit, 
  Trash2, 
  Building2,
  Building,
  Users,
  Upload,
  X,
  User,
  Mail,
  Phone,
  MapPin
} from 'lucide-react'
import { LoadingSpinner } from '../common'

function UserList({ 
  users, 
  isLoading, 
  onEdit, 
  onDelete, 
  onToggleStatus, 
  onAvatarSelect, 
  onAvatarDelete,
  isUploadingAvatar,
  isDeletingAvatar
}) {
  if (isLoading) {
    return <LoadingSpinner size="lg" className="h-64" />
  }

  return (
    <div className="card">
      <div className="card-content p-0">
        <div className="overflow-x-auto">
          <table className="table">
            <thead className="table-header">
              <tr className="table-row">
                <th className="table-head">User</th>
                <th className="table-head">Contact</th>
                <th className="table-head">Location</th>
                <th className="table-head">Role</th>
                <th className="table-head">Status</th>
                <th className="table-head">Actions</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {users.map((user) => (
                <tr key={user.id} className="table-row">
                  <td className="table-cell">
                    <div className="flex items-center">
                      <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center overflow-hidden">
                        {user.avatar ? (
                          <img 
                            src={user.avatar} 
                            alt={`${user.firstName} ${user.lastName} avatar`}
                            className="h-full w-full object-cover"
                            onError={(e) => {
                              console.error('Avatar load error:', user.avatar, e);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Avatar loaded successfully:', user.avatar);
                            }}
                          />
                        ) : (
                          <User className="h-4 w-4 text-primary-600" />
                        )}
                      </div>
                      <div className="ml-3">
                        <div className="text-sm font-medium text-secondary-900">
                          {user.firstName} {user.lastName}
                        </div>
                        <div className="text-sm text-secondary-500">
                          ID: {user.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900 flex items-center">
                      <Mail className="h-4 w-4 mr-2 text-secondary-400" />
                      {user.email}
                    </div>
                    <div className="text-base text-secondary-500 flex items-center">
                      <Phone className="h-4 w-4 mr-2 text-secondary-400" />
                      {user.phone || "N/A"}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900 flex items-center">
                      <MapPin className="h-4 w-4 mr-2 text-secondary-400" />
                      {user.city}, {user.state}
                    </div>
                    <div className="text-base text-secondary-500">
                      {user.pincode}
                    </div>
                  </td>
                  <td className="table-cell">
                    <span className="badge badge-primary">
                      {user.role?.name || "No Role"}
                    </span>
                  </td>
                  <td className="table-cell">
                    <span
                      className={`badge ${
                        user.isActive ? "badge-success" : "badge-danger"
                      }`}
                    >
                      {user.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => onEdit(user)}
                        className="text-primary-600 hover:text-primary-900"
                        title="Edit User"
                      >
                        <Edit className="h-4 w-4" />
                      </button>
                      <button
                        onClick={() => onToggleStatus(user)}
                        className={user.isActive ? 'text-danger-600 hover:text-danger-900' : 'text-success-600 hover:text-success-900'}
                        title={user.isActive ? 'Deactivate User' : 'Activate User'}
                      >
                        {user.isActive ? <Building className="h-4 w-4" /> : <Building2 className="h-4 w-4" />}
                      </button>
                      {user.avatar ? (
                        <button
                          onClick={() => onAvatarDelete(user.id)}
                          className="text-danger-600 hover:text-danger-900"
                          title="Delete Avatar"
                          disabled={isDeletingAvatar}
                        >
                          <X className="h-4 w-4" />
                        </button>
                      ) : (
                        <label className="text-primary-600 hover:text-primary-900 cursor-pointer" title="Upload Avatar">
                          <Upload className="h-4 w-4" />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => onAvatarSelect(e, user.id)}
                            className="hidden"
                            disabled={isUploadingAvatar}
                          />
                        </label>
                      )}
                      <button
                        onClick={() => onDelete(user)}
                        className="text-danger-600 hover:text-danger-900"
                        title="Delete User"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UserList;
